module.exports = __webpack_public_path__ + "static/img/page top img_clear_mobile.942118a2.jpg";